import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
  { name: 'Florian Tramèr', con: 'Stanford', img: 'https://img.alicdn.com/imgextra/i2/O1CN01n0ZkVH1TlmNRPITOj_!!6000000002423-2-tps-260-260.png' },
  { name: 'Jingfeng Zhang', con: 'RIKEN', img: 'https://img.alicdn.com/imgextra/i2/O1CN01qP4UHT24E0xgeOcjq_!!6000000007358-2-tps-260-260.png' },
  { name: 'Maksym Andriushchenko', con: 'EPFL', img: 'https://img.alicdn.com/imgextra/i3/O1CN014PohWE1beSypsZDjI_!!6000000003490-2-tps-260-260.png' },
  { name: 'Hadi Salman', con: 'MIT', img: 'https://img.alicdn.com/imgextra/i4/O1CN01tT9zuW1XE7jli2YTP_!!6000000002891-2-tps-260-260.png' },
  { name: 'Alex Lamb', con: 'MILA', img: 'https://img.alicdn.com/imgextra/i4/O1CN016yMKCa1nJeMvmn705_!!6000000005069-2-tps-260-260.png' },
  { name: 'Chaowei Xiao', con: 'Arizona State University', img: 'https://img.alicdn.com/imgextra/i2/O1CN01VaYTlG1xW9MjP60bx_!!6000000006450-2-tps-520-520.png' },
  { name: 'Xiaofeng Mao', con: 'Alibaba', img: 'https://img.alicdn.com/imgextra/i2/O1CN016V8vqy1EF3sEf0fbY_!!6000000000321-2-tps-520-520.png' },
]
export default function Invited() {
  return <div className="page-invited">
    <div className="invited-title">Invited Speakers</div>
    <Row className="list-ul">
      {arrs.map((item, index) => (<Col xl={6} md={12} span={24} key={index} className="list-li">
        <div className="list-two">
          <img src={item.img} alt="" />
          <div className="pro-div">
            <span>{item.name}</span>
            <b />
            <div dangerouslySetInnerHTML={{ __html: item.con }} />
          </div>

        </div>
      </Col>))}
    </Row>
  </div>
}
